import React from "react";
import PropTypes from "prop-types";
import TextInput from "components/v3/text-input/TextInput";
import ErrorHandler from "components/v3/error-handler/ErrorHandler";
import styles from "./styles.module.scss";

const EmailWithConfirm = (props) => {
    const {
        email,
        confirmEmail,
        checkEmailsMatch,
        errors,
        handleEmailChange,
        handleConfirmEmailChange,
        emailIsDisabled,
        autoFocus
    } = props;

    return (
        <div>
            <ErrorHandler type="email" errors={ errors }>
                <TextInput
                    name="email"
                    type="email"
                    placeholder="Enter your email"
                    value={ email }
                    onChange={ handleEmailChange }
                    disabled={ emailIsDisabled }
                    autoFocus={ autoFocus }
                    onBlur={ checkEmailsMatch }
                />
            </ErrorHandler>
            <div className={ styles.confirmEmail }>
                <ErrorHandler type="confirmEmail" errors={ errors }>
                    <TextInput
                        name="confirmEmail"
                        label="confirm email"
                        type="email"
                        placeholder="Confirm email address"
                        value={ confirmEmail }
                        onChange={ handleConfirmEmailChange }
                        disablePaste={ true }
                        autoFocus={ false }
                        showErrors={ true }
                    />
                </ErrorHandler>
            </div>
        </div>
    );
};

EmailWithConfirm.defaultProps = {
    autoFocus: true,
    emailIsDisabled: false
};

EmailWithConfirm.propTypes = {
    email: PropTypes.string,
    confirmEmail: PropTypes.string,
    errors: PropTypes.object,
    handleEmailChange: PropTypes.func,
    handleConfirmationEmailChange: PropTypes.func,
    emailIsDisabled: PropTypes.bool
};

export default EmailWithConfirm;
